<template>
  <div>
    <breadcrumbs home="Add empty casks to inventory"/>

    <v-card flat>
      <v-form v-model="valid" ref="form">
        <v-container class="pt-6 px-6 purtrak-scrollable" fluid @click="selectedCask = null">
          <v-row dense>
            <v-col cols="6" sm="4" lg="3">
              <date-picker v-model="transaction.date" @change="getItemLots(true)"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" lg="4">
              <v-autocomplete v-model="transaction.itemId" label="From inventory item" :items="items" item-value="id" item-text="name"
                              outlined dense/>
            </v-col>
            <v-col cols="4" lg="2" v-if="item.lotTracking">
              <v-combobox label="Lot" :items="itemLots" :return-object="false" item-text="lot" item-value="lot" v-model="transaction.lot" dense
                          :rules="[fieldRules.required,fieldRules.maxLength(20)]" outlined/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" lg="4" v-if="sites.length>1">
              <v-autocomplete outlined dense label="From site" v-model="transaction.fromSiteId" :items="sites" item-value="id" item-text="name" @change="getItemLots(true)"/>
            </v-col>
            <v-col cols="12" sm="6" lg="4" v-if="sites.length>1">
              <v-autocomplete outlined dense label="To site" v-model="transaction.toSiteId" :items="sites" item-value="id" item-text="name"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <outlined-block title="Casks" :rules="[casksValid]">
                <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                              :items="transaction.casks" item-key="key" no-data-text="No casks specified"
                              :item-class="item => item.key=== selectedCask ? ($vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4') : ''"
                              :headers="[{text:'',value:'add',width:'10%',align:'center',cellClass:'pa-0',divider:true},
                                        {text:'Number',value:'number',width:'15%',divider:true,class:'px-2',cellClass:'py-2 px-1'},
                                        {text:'Empty weight',value:'tare',width:'15%',align:'right',divider:true,class:'px-2',cellClass:'py-2 px-2'},
                                        {text:'Info',value:'info',width:'40%',divider:true,class:'px-2',cellClass:'py-2 px-2'},
                                        {text:'Location',value:'location',width:'20%',divider:true,class:'px-2',cellClass:'py-2 px-2'}]"
                              class="no-sort" ref="tableBody"
                              @click.native.stop=""
                              @click:row="item => {selectedCask = item.key; $nextTick(() => this.$refs.form.validate())}">
                  <template v-slot:item.add="{index}">
                    <v-btn class="mt-n2" icon @click.stop="deleteCask(index)" x-small><v-icon>mdi-delete</v-icon></v-btn>
                  </template>

                  <template v-slot:item.number="{item}">
                    <v-text-field v-if="selectedCask === item.key" label="Number" v-model="item.number" outlined dense
                                  :rules="[fieldRules.required,fieldRules.maxLength(10)]"/>
                    <div v-else :class="{'error--text':!item.number || item.number.length>10}">{{item.number || 'Required'}}</div>
                  </template>
                  <template v-slot:item.tare="{item}">
                    <template>
                      <decimal-number-input v-if="selectedCask === item.key" v-model="item.tare" label="Empty weight" prefix="" suffix="kg" :precision="3"/>
                      <div v-else :class="{'error--text':item.tare<0}">{{item.tare | number(3)}} kg</div>
                    </template>
                  </template>
                  <template v-slot:item.info="{item}">
                    <template>
                      <v-text-field v-if="selectedCask === item.key" v-model="item.info" outlined label="Info" dense class="text-caption" :rules="[fieldRules.maxLength(200)]"/>
                      <div v-else class="text-caption" :class="{'error--text':item.info && item.info.length>200}">{{item.info}}</div>
                    </template>
                  </template>
                  <template v-slot:item.location="{item}">
                    <template>
                      <v-text-field v-if="selectedCask === item.key" v-model="item.location" outlined label="Location" dense class="text-caption" :rules="[fieldRules.maxLength(20)]"/>
                      <div v-else class="text-caption" :class="{'error--text':item.location.length>20}">{{item.location}}</div>
                    </template>
                  </template>

                  <template v-slot:footer="{widths}">
                    <v-divider/>
                    <div @click="selectedCask = null" style="width:100%" class="py-2 px-0">
                      <div :styddle="'width:'+widths[0]+'px'" cklass="text-center">
                        <decimal-number-input prefix="" :precision="0" :min="1" label="Quantity" v-model="quantity" style="width:100px" class="d-inline-block mx-2" hideDetails/>
                        <v-btn fab color="primary" x-small @click.stop="addCask()"><v-icon small>mdi-plus</v-icon></v-btn>
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </outlined-block>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'InventoryCasksAddEmpty',

  mixins: [confirmLeave],

  data: () => {
    return {
      valid: true,
      saving: false,
      dirty: false,
      items: [],
      quantity: 1,
      nextNumber: 0,
      transaction: {date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'), itemId:'', lot:'', fromSiteId:'', toSiteId:'', casks:[]},
      selectedCask: null,
      itemLots: []
    }
  },

  computed: {
    sites() {
      return this.$store.getters.sites(!this.transactionId, {B265:true,B266:true});
    },
    casksValid()  {
      return !!this.transaction.casks.length || 'There must be at least one cask';
    },
    item() {
      return this.items.find(item => item.id === this.transaction.itemId) ?? {};
    }
  },

  watch: {
    transaction: {
      handler() {this.dirty = true},
      immediate: true,
      deep: true
    },
    item() {
      this.getItemLots(false);
    }
  },

  async created() {
    const results = await this.$apiCall(`query InventoryCasksAddEmpty {
                                            nextCaskNumber
                                          }`);
    if (results.error) {
      this.$router.back();
      return;
    }
    this.nextNumber = results.data.nextCaskNumber;

    this.transaction.fromSiteId = this.sites[0].id;
    this.transaction.toSiteId = this.sites[0].id;
    await this.$lazyListLoad(this.items, 'items2', 'id,name,lotTracking', 100, [{field:'active',comparator:'eq',value:'true'},{field:'type',comparator:'eq',value:'Item'}]);
    this.transaction.itemId = this.items[0].id;
//    this.addCask();
    this.$nextTick(() => this.dirty = false);
  },

  methods: {
    async getItemLots(force) {
      if ((!this.item.sites || force) && this.item.lotTracking) {
        const results = await this.$apiCall(`query InventoryCasksAddEmpty($id:ID!, $date:DateTime!) {
                                                item(id:$id) {
                                                  sites(asof:$date) {
                                                    siteId, lot
                                                  }
                                                }
                                              }`, {id:this.transaction.itemId, date:this.transaction.date});
        if (!results.error)
          this.item.sites = results.data.item.sites;
      }
      this.itemLots = this.item.sites?.filter(site => site.siteId === this.transaction.fromSiteId).map(site => site.lot) ?? [];
    },

    addCask() {
      let key = Date.now();
      for (let i = 0; i < this.quantity; i++) {
        const cask = {key, number:`${this.nextNumber++}`, tare:0, info:this.item.name, location:''};
        this.transaction.casks.push(cask);
        this.selectedCask = cask.key;
        key++;
      }
      this.$nextTick(() => this.$refs.form.validate());
    },

    deleteCask(index) {
      this.transaction.casks.splice(index, 1);
    },

    cancel() {
      this.$router.back();
    },

    async save() {
      if (!this.valid ||
          this.transaction.casks.some(cask => cask.number.length === 0 || cask.number.length > 10 ||
                                      cask.tare < 0 || cask.info.length>200 || cask.location.length>20)) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;

      const {casks, ...input} = this.transaction;
      input.casks = casks.map(cask => {
        const {key, ...caskInfo} = cask;
        return caskInfo;
      });
      const results = await this.$apiCall(`mutation InventoryCasksAddEmpty($input: CaskAddEmptyInput!) {
                                             caskAddEmptyCreate(input:$input) {id}
                                           }`,
                                          {input});
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`Moved ${input.casks.length} casks to empty cask inventory`});
      }
    }
  }
}
</script>